// src/api/apiClient.ts
import createAxiosInstance from './createAxiosInstance';

const getGlobalApiUrl = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5038/api'; // Default fallback

const api = createAxiosInstance({
  baseURL: getGlobalApiUrl, // 🔁 Can be loaded from env
  withAuth: true,
  timeout:0
});

export const apiClient = {
  get: async <T>(url: string, config?: object): Promise<T> => {
    const response = await api.get<T>(url, config);
    return response.data;
  },

  post: async <T>(url: string, data?: any, config?: object): Promise<T> => {
    const response = await api.post<T>(url, data, config);
    return response.data;
  },

  put: async <T>(url: string, data?: any, config?: object): Promise<T> => {
    const response = await api.put<T>(url, data, config);
    return response.data;
  },

  delete: async <T>(url: string, config?: object): Promise<T> => {
    const response = await api.delete<T>(url, config);
    return response.data;
  },
};
